import { render, staticRenderFns } from "./ProjectSalesView.vue?vue&type=template&id=177b7c05&"
import script from "./ProjectSalesView.vue?vue&type=script&lang=ts&"
export * from "./ProjectSalesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports